import Routes from 'routes/index'
import React, { Suspense } from 'react'
import Loader from 'components/ui-kit/Loader/index'
import RotateDeviceOverlay from 'components/layout/RotateDeviceOverlay/index'
import PokerAtmosphere from 'components/PokerAtmosphere'

function App () {
  return (
    <Suspense fallback={<Loader />}>
      <div className='relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden'>
        <PokerAtmosphere />
        <div className='relative z-[1] flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden'>
          <Routes />
        </div>
      </div>
      <RotateDeviceOverlay />
    </Suspense>
  )
}

export default App
